///////////////////////////////////////////////////////////////////////////////////////////////////
//GLOBAL VALUE START
///////////////////////////////////////////////////////////////////////////////////////////////////

const UA = window.navigator.userAgent.toLowerCase();
const IE = UA.indexOf('msie') != -1 || UA.indexOf('trident') != -1 || UA.indexOf('edge') != -1;
const IE11 = UA.indexOf('msie') != -1 || UA.indexOf('trident') != -1;
const iOS = UA.indexOf("iPhone") >= 0 || UA.indexOf("iPad") >= 0
let headerH;
let controller;
const MOUSEWHEELEVENT = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
let modalFlg = false;

/**
 * Google Fonts 非同期
 */
window.WebFontConfig = {
  google: {
    families: ['Noto+Sans+JP:400,700', 'Teko:600']
  },
  active: function () {
    sessionStorage.fonts = true;
  }
};

(function () {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();

/**
 *  breakPointでDevice判定
 */
const deviceFlg = () => {
  return window.innerWidth < BREAKE_POINT.pc ? true : false;
}

//responsive
const BREAKE_POINT = {
  pc: 900,
  sp: 750
}


let deviceIsSp = deviceFlg();

/** 
 * @class
 * @classdesc modal表示用のクラス
 */
class Modal {
  constructor(yt) {
    this._modal = document.querySelector(`.p-modal`);
    this._close = this._modal.querySelector(`.p-modal__closebtn`);
    this.yt = yt || ``;

    this._ytPlayer;
    this.youtubeSrc;

    this.clickClose();
  }

  open(callcback) {

    /**
     * Youtube埋め込みの際はタグを生成してそこにsrcを入れる
     */
    if (this.yt) {
      let iframe = document.createElement("iframe");
      iframe.setAttribute(`src`, ``);
      iframe.setAttribute(`frameborder`, 0);
      iframe.setAttribute(`allow`, `accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture`);
      iframe.setAttribute(`allowfullscreen`, ``);

      let div = document.createElement(`div`);
      div.setAttribute(`class`, `p-modal__mediainner`);
      div.appendChild(iframe);
      let wrap = document.querySelector(`.js-youtubePlayer`).appendChild(div);

      this._ytPlayer = wrap.querySelector(`iframe`);
      this.youtubeSrc = "https://www.youtube.com/embed/" + this.yt + "?rel=0";

      if (this._ytPlayer.getAttribute(`src`) == ``) {
        this._ytPlayer.setAttribute(`src`, this.youtubeSrc);
      }
    }

    document.body.classList.add(`stop-scrolling`);
    this._modal.style.overflowY = `scroll`;
    modalFlg = true;

    let callback = callcback || ``;
    let rgba = this._modal.classList.contains(`p-modal--light`) ? `rgba(0,0,0,0.65)` : `rgba(0,0,0,0.9)`;
    TweenMax.to(this._modal, 0.2, {
      alpha: 1,
      display: 'block',
      backgroundColor: rgba,
      onComplete: () => {
        if (callcback) callcback();
        if (document.querySelector(`.p-loading--another`) !== null) {
          document.querySelector(`.p-loading--another`).style.opacity = 0;
        }
      }
    });

    this._modal.classList.add(`is-open`);

  }

  clickClose() {
    this._close.addEventListener(`click`, (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.close();
    }, false);
  }

  bgClose() {
    let _media = document.querySelector(`.p-modal__media`);

    if( _media !== null ){
      _media.addEventListener(`click`, (e) => {
        e.stopPropagation();
      },false);
    }

    this._modal.addEventListener(`click`, (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.close();
    }, false);
  }

  close() {

    if (this.yt) {
      //document.querySelector(`.p-modal__mediainner`).remove();
    }

    let wrap = document.querySelector(`.js-modalwrap`);
    if (wrap !== null) {
      if (wrap.hasChildNodes()) {
        wrap.removeChild(wrap.lastChild);
      }
    }

    document.body.classList.remove(`stop-scrolling`);
    this._modal.style.overflowY = `auto`;
    modalFlg = false;

    if (document.querySelector(`.p-loading--another`) !== null) {
      document.querySelector(`.p-loading--another`).style.opacity = 1;
    }

    TweenMax.to(this._modal, 0.2, {
      alpha: 0,
      display: 'none',
    });

    this._modal.classList.remove(`is-open`);
  }

}



/**
 * いちいちdocument.querySlector書くのがめんどいので省略できる関数
 * multiple == true で document.querySlectorAll 
 */

const getElementAndCallFnc = (className, multiple, fnc) => {

  const MULTIPLE = multiple || null;
  let _element = MULTIPLE ? document.querySelectorAll(className) : document.querySelector(className);
  if (MULTIPLE && _element.length > 0) {
    for (let i = 0; i < _element.length; i++) {
      fnc(i, _element);
    }
  } else if (!MULTIPLE && _element !== null) {
    fnc(_element);
  }
}


/**
 * いちいちクラスあるか探すのめんどいので
 */
const searchClass = (target, classname) => {
  return document.querySelector(target).classList.contains(classname);
}


/**
 * anchorにスムーズスクロール
 */
const MoveAnchor = (speed, anchorID, offset) => {
  if( isNaN(anchorID) == true && document.querySelector(anchorID) == null ){
    return ;
  }
  TweenMax.to(window, speed, {
    scrollTo: {
      y: anchorID,
      offsetY: offset,
      autoKill: false
    }
  });
}


/**
 * メニュー用などのtoggle 用
 */
const toggleClass = (target, close, open) => {
  target.classList.toggle(close);
  target.classList.toggle(open);
}


/**
 * 間引き
 */
const throttleFunc = (fn, interval) => {
  //開始時間
  let time = performance.now()
  return () => {
    // 最後に実行した時間から間引きたい時間経過していたら実行
    if (time + interval < performance.now()) {
      fn();
      time = performance.now();
    }
  };
};


///////////////////////////////////////////////////////////////////////////////////////////////////
//GLOBAL VALUE END
///////////////////////////////////////////////////////////////////////////////////////////////////


///////////////////////////////////////////////////////////////////////////////////////////////////
//DOMContentLoaded START
///////////////////////////////////////////////////////////////////////////////////////////////////
document.addEventListener(`DOMContentLoaded`, () => {


  /**
   * tab切り替え
   */
  const _tab = document.querySelector(`.js-tab`);
  const _tabitem = document.querySelectorAll(`.js-tabitem`);
  if (_tab !== null) {
    const query = _tab.getAttribute(`data-query`);
    _tabitem.forEach((elem, index) => {
      if (elem.classList.contains(query)) {
        let _img = elem.querySelector(`img`);
        let imgsrc = _img.getAttribute(`src`).split(`.`);
        let newimgsrc = imgsrc[0] + `_on.` + imgsrc[1];
        _img.setAttribute(`src`, newimgsrc);
        return;
      }
    });
  }

  /**
   * IE Edge 用スムーズスクロール
   */
  if (IE) {

    const SMOOTHING = 2;
    const SPEED = 0.5;

    window.addEventListener(MOUSEWHEELEVENT, (e) => {
      if (modalFlg == false) {
        e.preventDefault();
        let wd = e.wheelDelta;
        let ofs = window.pageYOffset;
        let ieScroll = TweenMax.to(window, SPEED, {
          scrollTo: {
            y: ofs - wd * SMOOTHING
          }
        });
      }
    });
  }

  /**
   * modal用
   */
  let modalFnc = (index, _element) => {
    let modalObj;
    switch (_element[index].getAttribute(`data-yt`) !== ``) {
      case true:

        modalObj = new Modal(_element[index].getAttribute(`data-yt`));
        break;
      case false:
        modalObj = new Modal();
        break;
    }
    _element[index].addEventListener(`click`, (e) => {
      e.stopPropagation();
      e.preventDefault();
      modalObj.open();
      return false;
    });
  }

  let callYbModalFnc = getElementAndCallFnc(`.js-modal`, true, modalFnc);
  let callPureModalFnc = getElementAndCallFnc(`.js-puremodal`, true, modalFnc);


  /**
   * accrodin
   */
  let accordionFnc = (index, _thisElement) => {
    const ACTIVECLASS = `accordion--open`;
    let _btn = _thisElement[index].querySelector(`.js-accordion__btn`);
    _btn.addEventListener(`click`, (e) => {
      e.stopPropagation();
      e.preventDefault();
      _thisElement[index].classList.toggle(ACTIVECLASS);
      return false;
    });
  }

  let callAccordionFnc = getElementAndCallFnc(`.js-accordion`, true, accordionFnc);


});
///////////////////////////////////////////////////////////////////////////////////////////////////
//DOMContentLoaded END
///////////////////////////////////////////////////////////////////////////////////////////////////



///////////////////////////////////////////////////////////////////////////////////////////////////
//window On LOAD start
///////////////////////////////////////////////////////////////////////////////////////////////////
window.addEventListener('load', () => {



  const TweenFadeOut = (_element) => {
    TweenMax.to(_element, 1, {
      alpha: 0,
      display: `none`,
    });
  }

  const _loading = document.querySelector(`.js-loading`);

  if (_loading !== null) TweenFadeOut(_loading);

  //scrollMagic
  controller = new ScrollMagic.Controller();


  /**
   * ヘッダー追従
   */
  let _follow = document.querySelector(`.js-follow`);
  let _nav = document.querySelector(`.js-nav`);
  let _navbtn = document.querySelector(`.js-navbtn`);

  if (_follow !== null) {
    headerH = _follow.clientHeight;
    document.querySelector(`.l-header`).style.height = headerH + `px`;


    let headerFix = new ScrollMagic.Scene({
        triggerElement: `window`,
        triggerHook: 0, // 開始の上下
        reverse: true,
        offset: 0, //トリガーの要素の上下
      })
      .addTo(controller);

    let exScrollPos = 0;
    let nowScrollPos = 0;
    let scrollTimer; //ie用
    let duration = 200;
    let headerScoll = headerFix.on(`update`, function (event) {
      if (!deviceIsSp || (deviceIsSp && !_navbtn.classList.contains(`is-open`))) {
        nowScrollPos = event.scrollPos;
        if ((nowScrollPos < exScrollPos) || (nowScrollPos <= _follow.clientHeight)) {
          _follow.classList.add(`is-show`);
        } else if ((nowScrollPos > exScrollPos)) {
          _follow.classList.remove(`is-show`);
        }
        exScrollPos = event.scrollPos;
      }
    });

  }



  /**
   * navigation Anime
   */
  let _anchorE = document.querySelectorAll(`.p-nav__anchor li`) || ``;

  let fadeIn = new TimelineMax();

  if (_anchorE.length !== 0) {
    //オープン時のアニメ
    fadeIn.staggerFromTo(".p-nav__anchor li , .p-nav__block", 0.5, {
      opacity: 0,
      x: 10
    }, {
      opacity: 1,
      x: 0
    }, 0.1);
    fadeIn.pause();

    let _blockE = document.querySelectorAll(`.p-nav__block`);

    _navbtn.addEventListener(`click`, (e) => {
      e.preventDefault();
      e.stopPropagation();
      openNav(_navbtn, _nav, fadeIn);
    }, false);

  }



  const openNav = (e, _n, tw) => {
    let close = `is-close`;
    let open = `is-open`;
    let target = e;
    let flg = target.classList.contains(close) ? true : false;

    document.body.classList.toggle(`stop-scrolling`);

    if (flg) { //closeの時

      _n.style.display = `block`;
      toggleClass(target, `is-close`, `is-open`);
      tw.restart();

    } else { //openのとき

      _n.style.display = `none`;
      toggleClass(target, `is-close`, `is-open`);

    }

  }



  /**
   * anchor
   */
  let anchorsFnc = (index, _element) => {

    _element[index].addEventListener('click', (e) => {
      e.preventDefault();
      if (searchClass(`.js-navbtn`, `is-open`)) {

        let _nav = document.querySelector(`.js-nav`);
        let _navbtn = document.querySelector(`.js-navbtn`);
        document.body.classList.toggle(`stop-scrolling`);
        _nav.style.display = `none`;
        toggleClass(_navbtn, `is-close`, `is-open`);

      }

      let href = e.currentTarget.getAttribute('href');
      MoveAnchor(1, href, -1);

      return false;
    })

  }

  let callAnchorsFnc = getElementAndCallFnc(`.js-anchor`, true, anchorsFnc);



  /**
   * pagetop triger-start ~ triger-endの中で表示
   */
  let pagetopFnc = (_element) => {

    let _pageTopInner = document.querySelector(`.js-pagetop-inner`);

    _element.addEventListener('click', (e) => {
      e.preventDefault();
      MoveAnchor(1, 0, 0);
      return false;
    })

    let callTrigerStartFnc = getElementAndCallFnc(`.js-pagetop-triger-start`, ``, duringUnderTrigerStart);
    let callTrigerEndFnc = getElementAndCallFnc(`.js-pagetop-triger-end`, ``, enterTrigerEnd);
  }

  //triger-startの上か下かで表示切り替え
  let duringUnderTrigerStart = () => {
    let pageTopScroll_start = new ScrollMagic.Scene({
        triggerElement: `.js-pagetop-triger-start`,
        triggerHook: 1, // 開始の上下
        reverse: true,
        offset: 0, //トリガーの要素の上下
      })
      .addTo(controller);

    let _pageTopInner = document.querySelector(`.js-pagetop-inner`);

    pageTopScroll_start.on(`enter`, (event) => {
      let flg = searchClass(`.js-pagetop-inner`, `is-hide`);
      if (flg) {
        _pageTopInner.classList.remove(`is-hide`);
      } else {
        _pageTopInner.classList.add(`is-hide`);
      }

    })

    pageTopScroll_start.on(`leave`, (event) => {

      let flg = _pageTopInner.classList.contains(`is-hide`);
      if (!flg) {
        _pageTopInner.classList.add(`is-hide`);
      } else {

      }

    })

  }


  //triger-endの上か下かで表示切り替え
  let enterTrigerEnd = () => {

    let pageTopScroll_end = new ScrollMagic.Scene({
        triggerElement: `.js-pagetop-triger-end`,
        triggerHook: 1, // 開始の上下
        reverse: true,
        offset: -100, //トリガーの要素の上下
      })
      .addTo(controller);

    let _pageTopInner = document.querySelector(`.js-pagetop-inner`);

    pageTopScroll_end.on(`enter`, (event) => {

      let flg = searchClass(`.js-pagetop-inner`, `is-hide`);
      if (!flg) {
        _pageTopInner.classList.add(`is-hide`);
      }

    })

    pageTopScroll_end.on(`leave`, (event) => {

      let flg = searchClass(`.js-pagetop-inner`, `is-hide`);
      if (flg) {
        _pageTopInner.classList.remove(`is-hide`);
      }

    })

  }


  let callPagetopFnc = getElementAndCallFnc(`.js-pagetop-anchor`, ``, pagetopFnc);





  /**
   * 特設などでメインビジュアルに画面フィット実装したいとき
   */
  /**
   * mainvis 縦幅 100%フィット
   */
  let _maxH, _header, _followArray = [];

  const initHeaderFollow = () => {
    _maxH = document.querySelectorAll(`.js-MaxHeight`);
    if (_maxH.length !== 0) {
      _header = document.querySelector(`.l-header`);
      _followArray = [document.querySelector(`.js-follow`), document.querySelector(`.js-appstore`)];
      _header.style.height = document.querySelector(`.js-follow`).clientHeight + `px`;
    }
  }

  initHeaderFollow();

  let fh = new MaxHeight(_maxH, _followArray);


  let resizeFnc = () => {
    if (_follow !== null) {
      headerH = _follow.clientHeight;
      document.querySelector(`.l-header`).style.height = headerH + `px`;
      if (!deviceIsSp && _navbtn.classList.contains(`is-open`)) { //pcの時open
        openNav(_navbtn, _nav, fadeIn);
      }
    }
  }

  let resizing = throttleFunc(resizeFnc, 200);

  /**
   * RESIZE
   */
  let windowW = window.innerWidth;
  window.addEventListener(`resize`, () => {


    deviceIsSp = deviceFlg();
    resizing();
    if (windowW !== window.innerWidth) {
      fh.reset();
    }

    windowW = window.innerWidth;

  }, false);


});
///////////////////////////////////////////////////////////////////////////////////////////////////
//window On LOAD end
///////////////////////////////////////////////////////////////////////////////////////////////////